import * as moment from 'moment';

/**
 *  Модуль работы с датами и временем
 * */

export class DxDateTime {

  /** используемые форматы текстового представления даты и времени */
  public static dateTimeFormats = {
    'datetime' : 'DD.MM.YYYY HH:mm',
    'date'     : 'DD.MM.YYYY',
    'time'     : 'HH:mm',
    'month'    : 'MMMM YYYY',
    'year'     : 'YYYY'
  };

  /** преобразование строковой даты/времени к типу Date*/
  public static strToDateTime(dateTimeStr: string, dateTimeFormat: string): Date {
    return dateTimeStr ? moment(dateTimeStr, dateTimeFormat).toDate() : null;
  }

  /** проебразование даты/времени в строку */
  public static dateTimeToStr(dateTime: Date,  dateTimeFormat: string): string {
    return dateTime ? moment(dateTime).format(dateTimeFormat) : '';
  }

}

export const MOMENT_DURATION_FORMAT_RU = {
  durationLabelsStandard: {
    S: 'милисекунда',
    SS: 'милисекунды',
    SSS: 'милисекунд',
    s: 'секунда',
    ss: 'секунды',
    sss: 'секунд',
    m: 'минута',
    mm: 'минуты',
    mmm: 'минут',
    h: 'час',
    hh: 'часа',
    hhh: 'часов',
    d: 'день',
    dd: 'дня',
    ddd: 'дней',
    w: 'неделя',
    ww: 'недели',
    www: 'недель',
    M: 'месяц',
    MM: 'месяца',
    MMM: 'месацев',
    y: 'год',
    yy: 'года',
    yyy: 'лет'
  },

  durationLabelsShort: {
    S: 'мсек',
    SS: 'мсек',
    s: 'сек',
    ss: 'сек',
    m: 'мин',
    mm: 'мин',
    h: 'час',
    hh: 'час',
    d: 'дн',
    dd: 'дн',
    w: 'нед',
    ww: 'нед',
    M: 'мес',
    MM: 'мес',
    y: 'год',
    yy: 'лет'
  },

  durationTimeTemplates: {
    HMS: 'h:mm:ss',
    HM: 'h:mm',
    MS: 'm:ss'
  },

  durationLabelTypes: [
    { type: "standard", string: "__" },
    { type: "short", string: "_" }
  ],

  /**
   * @param token
   * String. A single character representing the unit type.

   years:   y
   months:  M
   weeks:   w
   days:    d
   hours:   h
   minutes: m
   seconds: s
   ms:      S

   @param integerValue
   Number. The integer portion of the token's value.

   @param decimalValue
   Number. The decimal fraction portion of the token's value.

   @description I have implemented for durationLabelTypes === standard
   */
  durationPluralKey: function (token, integerValue: number, decimalValue: number) {

    if (decimalValue!=null) {
      return token + token + token;
    }

    if (integerValue === 1) {
      return token;
    }

    if (1 < integerValue && integerValue < 5) {
      return token + token;
    }

    return token + token + token;
  }
};
